import { Link } from 'react-router-dom';
import { siteConfig, trustFeatures } from '@/mocks/siteData';

export default function AboutSection() {
  return (
    <section className="bg-foreground-950 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-6xl mx-auto text-center">
        <p className="text-sm text-foreground-400 font-light tracking-wider mb-4">
          Trusted Mulebuy Spreadsheet Resource Since 2025
        </p>

        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-semibold text-white leading-tight max-w-3xl mx-auto mb-8">
          The Complete Mulebuy Spreadsheet System for Smarter Global Shopping
        </h2>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
          <a
            href={siteConfig.mainSite}
            target="_blank"
            rel="noopener nofollow"
            className="px-7 py-3 bg-white text-foreground-950 rounded-md font-semibold text-sm hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Mulebuy Tools
          </a>
          <Link
            to="/mulebuy-spreadsheet-complete-guide"
            className="px-7 py-3 border border-white/30 text-white rounded-md font-semibold text-sm hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Safety Guide
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {trustFeatures.map((feature) => (
            <div
              key={feature.label}
              className="bg-foreground-900/60 rounded-xl p-5 md:p-6 text-center hover:bg-foreground-800/60 transition-colors"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-accent-400`}></i>
              </div>
              <p className="text-sm text-white/80 font-medium">{feature.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}